import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { AppComponent } from "./app.component";

import * as fromGuards from "./guards";

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: "always",
};

const routes: Routes = [
  // { path: '', component: AppComponent },
  {
    path: "auth",
    loadChildren: () =>
      import("./views/auth/auth.module").then((module) => module.AuthModule),
  },
  {
    path: "crm",
    loadChildren: () =>
      import("./views/crm/crm.module").then((module) => module.CRMModule),
    canActivate: [fromGuards.AuthGuardService, fromGuards.CRMGuard],
  },
  {
    path: "reviewer",
    loadChildren: () =>
      import("./views/reviewer/reviewer.module").then(
        (module) => module.ReviewerModule
      ),
    canActivate: [fromGuards.AuthGuardService, fromGuards.REVIEWERGuard],
  },
  {
    path: "engineer",
    loadChildren: () =>
      import("./views/engineer/reviewer.module").then(
        (module) => module.ReviewerModule
      ),
    canActivate: [fromGuards.AuthGuardService, fromGuards.ENGINEERGuard],
  },
  {
    path: "super-admin",
    loadChildren: () =>
      import("./views/super-admin/super-admin.module").then(
        (module) => module.SuperAdminModule
      ),
    canActivate: [fromGuards.AuthGuardService, fromGuards.SuperAdminGuard],
  },
  {
    path: "teacher",
    loadChildren: () =>
      import("./views/teacher/teacher.module").then(
        (module) => module.TeacherModule
      ),
    canActivate: [fromGuards.AuthGuardService, fromGuards.TeacherGuard],
  },
  {
    path: "member",
    loadChildren: () =>
      import("./views/member/member.module").then(
        (module) => module.MemberModule
      ),
    canActivate: [fromGuards.AuthGuardService, fromGuards.MemberGuard],
  },
  {
    path: "my-stats",
    loadChildren: () =>
      import("./views/member-stats/member-stats.module").then(
        (module) => module.MemberStatsModule
      ),
    canActivate: [fromGuards.AuthGuardService],
  },
  {
    path: "siraj",
    loadChildren: () =>
      import("./views/super-admin/views/siraj/siraj.module").then(
        (module) => module.SirajModule
      ),
    canActivate: [fromGuards.AuthGuardService], // Only requires valid token, no role check
  },
  {
    path: "guest",
    loadChildren: () =>
      import("./views/super-admin/views/siraj/siraj.module").then(
        (module) => module.SirajModule
      ),
    // No guards - public access for demos and sharing
  },
  {
    path: "siraj/guest",
    loadChildren: () =>
      import("./views/super-admin/views/siraj/siraj.module").then(
        (module) => module.SirajModule
      ),
    // No guards - public access for mobile WebView guest mode
  },
  {
    path: "trial",
    loadChildren: () =>
      import("./views/super-admin/views/siraj/siraj.module").then(
        (module) => module.SirajModule
      ),
    data: { isTrial: true },
    // No guards - public access for QT trial participants
  },
  {
    path: "privacy-policy",
    loadChildren: () =>
      import("./views/privacy-policy/privacy-policy.module").then(
        (module) => module.PrivacyPolicyModule
      ),
  },
  {
    path: "email-preferences",
    loadChildren: () =>
      import(
        "./shared-modules/email-preferences/email-preferences.module"
      ).then((module) => module.EmailPreferencesModule),
    canActivate: [fromGuards.AuthGuardService],
  },
  {
    path: "unsubscribe",
    loadChildren: () =>
      import(
        "./shared-modules/unsubscribe/unsubscribe.module"
      ).then((module) => module.UnsubscribeModule),
  },
  {
    path: "resubscribe",
    loadChildren: () =>
      import(
        "./shared-modules/resubscribe/resubscribe.module"
      ).then((module) => module.ResubscribeModule),
  },
  { path: "", redirectTo: "super-admin", pathMatch: "full" },
  {
    path: "**",
    loadChildren: () =>
      import("./views/not-found/not-found.module").then(
        (module) => module.NotFoundModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
